module.exports = __webpack_public_path__ + "static/media/rtk.35eddce7.png";